/* mobile-menu.js - COMPLETE FIX with ALL Premium Features for Nutriop Longevity */

(function() {
  // Prevent multiple initializations with a simple flag
  if (window.mobileMenuInitialized) return;
  window.mobileMenuInitialized = true;

  let menuDrawer = null;
  let backdrop = null;
  let closeButton = null;
  
  // Core menu functions
  function openMenu() {
    if (!menuDrawer) return;
    
    menuDrawer.classList.add('menu-drawer--open', 'active');
    
    if (backdrop) {
      backdrop.classList.add('menu-drawer-backdrop--visible');
      // CRITICAL FIX: Enable pointer events when visible
      backdrop.style.pointerEvents = 'auto';
      backdrop.style.opacity = '1';
      backdrop.style.visibility = 'visible';
    }
    
    document.body.classList.add('menu-open');
    document.body.style.overflow = 'hidden';
    
    const detailsParent = menuDrawer.closest('details');
    if (detailsParent) {
      detailsParent.setAttribute('open', '');
      detailsParent.classList.add('menu-opening');
    }
    
    menuDrawer.setAttribute('aria-hidden', 'false');
    
    setTimeout(() => {
      if (closeButton) closeButton.focus();
    }, 300);
  }
  
  function closeMenu() {
    // CRITICAL FIX: Close details element FIRST to hide CSS pseudo-element backdrop
    const detailsParent = menuDrawer?.closest('details');
    if (detailsParent) {
      detailsParent.removeAttribute('open');
      detailsParent.classList.remove('menu-opening');
      // Force close by setting open property to false
      detailsParent.open = false;
    }
    
    if (menuDrawer) {
      menuDrawer.classList.remove('menu-drawer--open', 'active');
      menuDrawer.setAttribute('aria-hidden', 'true');
      // CRITICAL FIX: Force hide the menu drawer
      menuDrawer.style.visibility = 'hidden';
      menuDrawer.style.transform = 'translateX(-100%)';
    }
    
    if (backdrop) {
      backdrop.classList.remove('menu-drawer-backdrop--visible');
      // CRITICAL FIX: Disable pointer events when hidden
      backdrop.style.pointerEvents = 'none';
      backdrop.style.opacity = '0';
      backdrop.style.visibility = 'hidden';
    }
    
    // CRITICAL FIX #1: Remove ALL overflow-related classes including overflow-hidden-tablet
    document.body.classList.remove('menu-open');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-tablet'); // THE KEY FIX!
    document.body.classList.remove('overflow-hidden-mobile');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.documentElement.style.overflow = '';
    
    // Also remove any header-drawer related classes
    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer) {
      const headerDetails = headerDrawer.querySelector('details');
      if (headerDetails) {
        headerDetails.removeAttribute('open');
        headerDetails.open = false;
      }
    }
    
    // CRITICAL FIX #2: Remove focus from close button to prevent aria-hidden error
    if (closeButton) {
      closeButton.blur();
    }
    
    const menuButton = document.querySelector('.header__icon--menu');
    if (menuButton) {
      menuButton.setAttribute('aria-expanded', 'false');
      // Small delay before focusing to ensure menu is closed
      setTimeout(() => {
        menuButton.focus();
      }, 50);
    }
  }
  
  function toggleMenu(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (menuDrawer?.classList.contains('menu-drawer--open') || 
        menuDrawer?.classList.contains('active')) {
      closeMenu();
    } else {
      openMenu();
    }
  }
  
  // Global click handler
  function handleGlobalClick(e) {
    // Check if menu is open
    if (!document.body.classList.contains('menu-open')) return;
    
    // Check if click is on close button
    if (e.target.classList.contains('menu-drawer__close') || 
        e.target.closest('.menu-drawer__close')) {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
      return;
    }
    
    // Check if click is on backdrop
    if (e.target.classList.contains('menu-drawer-backdrop') ||
        e.target.classList.contains('menu-drawer-backdrop--visible')) {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
      return;
    }
    
    // Check if click is outside menu (on page content)
    const isClickInsideMenu = e.target.closest('#menu-drawer');
    const isClickOnMenuButton = e.target.closest('.header__icon--menu');
    
    if (!isClickInsideMenu && !isClickOnMenuButton) {
      closeMenu();
    }
  }
  
  // ESC key handler
  function handleEscKey(e) {
    if (e.key === 'Escape' && document.body.classList.contains('menu-open')) {
      closeMenu();
    }
  }
  
  // Setup swipe gestures
  function setupSwipeGestures() {
    if (!menuDrawer) return;
    
    let touchStartX = 0;
    let touchEndX = 0;
    
    menuDrawer.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    menuDrawer.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      if (touchStartX - touchEndX > 50) {
        closeMenu();
      }
    }, { passive: true });
  }
  
  // Initialize menu system
  function initializeMenu() {
    menuDrawer = document.getElementById('menu-drawer');
    if (!menuDrawer) return;
    
    // CRITICAL FIX: Ensure menu starts hidden
    menuDrawer.style.visibility = 'hidden';
    menuDrawer.style.transform = 'translateX(-100%)';
    
    // Create/find backdrop with proper styling
    backdrop = document.querySelector('.menu-drawer-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'menu-drawer-backdrop';
      
      // Apply critical inline styles for functionality
      // CRITICAL: pointer-events MUST be 'none' when hidden!
      backdrop.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999998;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: opacity 0.3s ease, visibility 0.3s ease;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
      `;
      
      document.body.appendChild(backdrop);
    } else {
      // Ensure existing backdrop has proper styles
      backdrop.style.position = 'fixed';
      backdrop.style.top = '0';
      backdrop.style.left = '0';
      backdrop.style.width = '100%';
      backdrop.style.height = '100%';
      backdrop.style.background = 'rgba(0, 0, 0, 0.5)';
      backdrop.style.zIndex = '999998';
      backdrop.style.opacity = '0';
      backdrop.style.visibility = 'hidden';
      backdrop.style.pointerEvents = 'none';
      backdrop.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
      backdrop.style.cursor = 'pointer';
      backdrop.style.webkitTapHighlightColor = 'transparent';
    }
    
    // Add style for visible state AND fix for CSS pseudo-element backdrop
    const style = document.createElement('style');
    style.id = 'menu-drawer-backdrop-styles';
    if (!document.getElementById('menu-drawer-backdrop-styles')) {
      style.textContent = `
        /* JS Backdrop visibility controls */
        .menu-drawer-backdrop--visible {
          opacity: 1 !important;
          visibility: visible !important;
          pointer-events: auto !important;
        }
        
        /* Ensure backdrop is completely non-interactive when hidden */
        .menu-drawer-backdrop:not(.menu-drawer-backdrop--visible) {
          pointer-events: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
        }
        
        /* CRITICAL FIX: CSS pseudo-element backdrop from theme */
        /* Ensure the summary::before pseudo-element doesn't block clicks when closed */
        .js menu-drawer > details:not([open]) > summary::before,
        .js menu-drawer > details > summary::before {
          pointer-events: none !important;
        }
        
        /* Only allow clicks on pseudo-element when menu is actually open */
        .js menu-drawer > details[open].menu-opening > summary::before {
          pointer-events: auto !important;
        }
        
        /* CRITICAL FIX: Ensure menu drawer is completely hidden when closed */
        #menu-drawer:not(.menu-drawer--open):not(.active) {
          visibility: hidden !important;
          transform: translateX(-100%) !important;
        }
        
        /* CRITICAL FIX: Prevent overflow classes from blocking page interaction */
        body.overflow-hidden-tablet,
        body.overflow-hidden-mobile {
          pointer-events: auto !important;
        }
        
        body:not(.menu-open) {
          overflow: visible !important;
        }
      `;
      document.head.appendChild(style);
    }
    
    // Create/find close button
    closeButton = menuDrawer.querySelector('.menu-drawer__close');
    if (!closeButton) {
      closeButton = document.createElement('button');
      closeButton.className = 'menu-drawer__close';
      closeButton.setAttribute('aria-label', 'Close menu');
      closeButton.setAttribute('type', 'button');
      closeButton.innerHTML = '<span class="visually-hidden">Close menu</span>';
      
      const menuInner = menuDrawer.querySelector('.menu-drawer-inner-container, .menu-drawer__inner-container');
      if (menuInner) {
        menuInner.insertBefore(closeButton, menuInner.firstChild);
      } else {
        menuDrawer.insertBefore(closeButton, menuDrawer.firstChild);
      }
    }
    
    // Setup event listeners
    const menuButton = document.querySelector('.header__icon--menu');
    if (menuButton) {
      menuButton.removeEventListener('click', toggleMenu);
      menuButton.addEventListener('click', toggleMenu);
    }
    
    if (closeButton) {
      closeButton.removeEventListener('click', closeMenu);
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
      });
    }
    
    // CRITICAL: Backdrop click handler with proper event handling
    if (backdrop) {
      backdrop.removeEventListener('click', handleBackdropClick);
      backdrop.addEventListener('click', handleBackdropClick);
    }
    
    // Global delegation for any close button
    document.removeEventListener('click', handleGlobalClick);
    document.addEventListener('click', handleGlobalClick);
    
    // ESC key
    document.removeEventListener('keydown', handleEscKey);
    document.addEventListener('keydown', handleEscKey);
    
    // Touch gestures
    setupSwipeGestures();
    
    // Handle details/summary pattern
    const summaryElement = document.querySelector('menu-drawer > details > summary');
    if (summaryElement) {
      summaryElement.removeEventListener('click', toggleMenu);
      summaryElement.addEventListener('click', function(e) {
        e.preventDefault();
        toggleMenu(e);
      });
    }
    
    // Initialize premium features
    initializePremiumInteractions();
  }
  
  // Dedicated backdrop click handler
  function handleBackdropClick(e) {
    e.preventDefault();
    e.stopPropagation();
    closeMenu();
  }
  
  // ============================================
  // PREMIUM MOBILE DRAWER INTERACTIONS
  // Nutriop Longevity Enhanced Experience
  // ============================================
  
  function initializePremiumInteractions() {
    // Force rectangular design on language switcher buttons
    function styleLanguageSwitcher() {
      const langButtons = document.querySelectorAll(
        '#menu-drawer .menu-drawer__localization .disclosure__button, ' +
        '#menu-drawer .menu-drawer__localization .localization-form__select'
      );
      
      langButtons.forEach(button => {
        // Apply rectangular button styles
        button.style.cssText = `
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 10px !important;
          width: 100% !important;
          height: 60px !important;
          border-radius: 30px !important;
          background: #FF8A8A !important;
          border: none !important;
          padding: 0 24px !important;
          color: white !important;
          font-size: 18px !important;
          font-weight: 600 !important;
          letter-spacing: 0.5px !important;
          text-transform: uppercase !important;
          box-shadow: 0 2px 8px rgba(255, 107, 107, 0.25), 0 4px 16px rgba(255, 107, 107, 0.15) !important;
          transition: all 0.3s ease !important;
        `;
        
        // Style flag images within buttons
        const flagImg = button.querySelector('.flag-image img');
        if (flagImg) {
          flagImg.style.cssText = `
            width: 28px !important;
            height: 20px !important;
            object-fit: contain !important;
            border-radius: 3px !important;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15) !important;
          `;
        }
        
        // Style the flag container
        const flagContainer = button.querySelector('.flag-image');
        if (flagContainer) {
          flagContainer.style.cssText = `
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: auto !important;
            height: auto !important;
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
            margin: 0 !important;
            padding: 0 !important;
          `;
        }
        
        // Style text elements
        const textSpans = button.querySelectorAll('span:not(.flag-image):not(.icon-caret)');
        textSpans.forEach(span => {
          span.style.color = 'white !important';
        });
        
        // COMPLETE ARROW REPLACEMENT SOLUTION
        // Step 1: Find and hide ALL existing arrow elements
        const allPossibleArrows = button.querySelectorAll('.icon-caret, svg, .icon, [class*="arrow"], [class*="caret"]');
        allPossibleArrows.forEach(element => {
          // Make sure we're not hiding flag images
          if (!element.closest('.flag-image') && element !== flagContainer && element !== flagImg) {
            // Force hide the original arrow
            element.style.setProperty('display', 'none', 'important');
            element.style.setProperty('visibility', 'hidden', 'important');
            element.style.setProperty('opacity', '0', 'important');
            element.style.setProperty('width', '0', 'important');
            element.style.setProperty('height', '0', 'important');
            element.style.setProperty('position', 'absolute', 'important');
            element.style.setProperty('left', '-9999px', 'important');
          }
        });
        
        // Step 2: Check if custom arrow already exists
        let customArrow = button.querySelector('.nutriop-custom-arrow');
        
        // Step 3: Create custom arrow if it doesn't exist
        if (!customArrow) {
          customArrow = document.createElement('span');
          customArrow.className = 'nutriop-custom-arrow';
          customArrow.innerHTML = '▼'; // Unicode down arrow
          customArrow.style.cssText = `
            color: rgba(255, 255, 255, 0.8) !important;
            font-size: 11px !important;
            font-weight: normal !important;
            margin-left: auto !important;
            margin-right: 0 !important;
            padding-left: 10px !important;
            line-height: 1 !important;
            display: inline-block !important;
            flex-shrink: 0 !important;
            transition: transform 0.3s ease, opacity 0.2s ease !important;
            transform-origin: center !important;
            position: relative !important;
            top: 0 !important;
            pointer-events: none !important;
          `;
          
          // Add the custom arrow to the button
          button.appendChild(customArrow);
        }
        
        // Step 4: Handle rotation on click
        if (!button.hasAttribute('data-arrow-listener')) {
          button.setAttribute('data-arrow-listener', 'true');
          button.addEventListener('click', function() {
            const arrow = this.querySelector('.nutriop-custom-arrow');
            if (arrow) {
              // Check if button is expanded
              const isExpanded = this.getAttribute('aria-expanded') === 'true';
              
              // Rotate arrow based on state
              if (isExpanded) {
                arrow.style.setProperty('transform', 'rotate(180deg)', 'important');
                arrow.style.setProperty('opacity', '1', 'important');
              } else {
                arrow.style.setProperty('transform', 'rotate(0deg)', 'important');
                arrow.style.setProperty('opacity', '0.8', 'important');
              }
            }
          });
        }
        
        // Step 5: Clean up any SVG elements that might be outside our selectors
        const svgElements = button.getElementsByTagName('svg');
        Array.from(svgElements).forEach(svg => {
          if (!svg.closest('.flag-image')) {
            svg.style.setProperty('display', 'none', 'important');
          }
        });
        
        // Add hover effect
        if (!button.hasAttribute('data-hover-listener')) {
          button.setAttribute('data-hover-listener', 'true');
          button.addEventListener('mouseenter', function() {
            this.style.background = '#FF7070 !important';
            this.style.transform = 'translateY(-2px)';
          });
          
          button.addEventListener('mouseleave', function() {
            this.style.background = '#FF8A8A !important';
            this.style.transform = 'translateY(0)';
          });
        }
      });
    }

    // Cleanup function to ensure arrows stay hidden
    function cleanupArrows() {
      setTimeout(() => {
        const buttons = document.querySelectorAll('#menu-drawer .menu-drawer__localization .disclosure__button');
        buttons.forEach(button => {
          // Hide any arrows that might have reappeared
          const unwantedArrows = button.querySelectorAll('.icon-caret, svg:not(.nutriop-custom-arrow)');
          unwantedArrows.forEach(arrow => {
            if (!arrow.closest('.flag-image')) {
              arrow.style.setProperty('display', 'none', 'important');
            }
          });
        });
      }, 100);
    }
    
    // Call the styling function immediately
    styleLanguageSwitcher();
    
    // Call cleanup after styling
    cleanupArrows();
    
    // Enhanced ripple effects for touch feedback
    const premiumElements = document.querySelectorAll(
      '.menu-drawer__localization .disclosure__button, ' +
      '.menu-drawer__account, ' +
      '.mobile-collection .card-collection-item-one'
    );
    
    premiumElements.forEach(element => {
      if (element.hasAttribute('data-touch-initialized')) return;
      element.setAttribute('data-touch-initialized', 'true');
      
      // Add touch feedback
      element.addEventListener('touchstart', handleTouchStart, { passive: true });
      element.addEventListener('touchend', handleTouchEnd, { passive: true });
      element.addEventListener('click', handleRippleClick);
    });
    
    // Handle language/country switcher interactions
    const localizationButtons = document.querySelectorAll('.menu-drawer__localization .disclosure__button');
    localizationButtons.forEach(button => {
      if (button.hasAttribute('data-disclosure-initialized')) return;
      button.setAttribute('data-disclosure-initialized', 'true');
      
      button.addEventListener('click', function(e) {
        // Close other dropdowns
        localizationButtons.forEach(otherButton => {
          if (otherButton !== this && otherButton.getAttribute('aria-expanded') === 'true') {
            const disclosure = otherButton.closest('.disclosure');
            if (disclosure) {
              const listWrapper = disclosure.querySelector('.disclosure__list-wrapper');
              if (listWrapper) {
                listWrapper.setAttribute('hidden', '');
                otherButton.setAttribute('aria-expanded', 'false');
              }
            }
          }
        });
      });
    });
    
    // Smooth scroll for menu drawer with iOS bounce fix
    if (menuDrawer) {
      const navigationContainer = menuDrawer.querySelector('.menu-drawer__navigation-container');
      if (navigationContainer && !navigationContainer.hasAttribute('data-scroll-initialized')) {
        navigationContainer.setAttribute('data-scroll-initialized', 'true');
        navigationContainer.style.webkitOverflowScrolling = 'touch';
        navigationContainer.style.scrollBehavior = 'smooth';
        
        // Prevent overscroll on iOS
        let startY = 0;
        navigationContainer.addEventListener('touchstart', function(e) {
          startY = e.touches[0].pageY;
        }, { passive: true });
        
        navigationContainer.addEventListener('touchmove', function(e) {
          const scrollTop = navigationContainer.scrollTop;
          const scrollHeight = navigationContainer.scrollHeight;
          const clientHeight = navigationContainer.clientHeight;
          const currentY = e.touches[0].pageY;
          const isScrollingUp = currentY > startY;
          const isScrollingDown = currentY < startY;
          
          if ((scrollTop === 0 && isScrollingUp) || 
              (scrollTop + clientHeight >= scrollHeight && isScrollingDown)) {
            e.preventDefault();
          }
        }, { passive: false });
      }
    }
    
    // Haptic feedback for premium buttons (if supported)
    if (window.navigator && window.navigator.vibrate) {
      document.querySelectorAll('.menu-drawer__account').forEach(btn => {
        if (btn.hasAttribute('data-haptic-initialized')) return;
        btn.setAttribute('data-haptic-initialized', 'true');
        btn.addEventListener('touchstart', () => {
          window.navigator.vibrate(8); // Light haptic tap
        }, { passive: true });
      });
      
      // Stronger feedback for featured collections
      document.querySelectorAll('.mobile-collection .card-collection-item-one').forEach(card => {
        if (card.hasAttribute('data-haptic-initialized')) return;
        card.setAttribute('data-haptic-initialized', 'true');
        card.addEventListener('touchstart', () => {
          window.navigator.vibrate(12);
        }, { passive: true });
      });
    }
    
    // Add visual feedback for active states
    function handleTouchStart(e) {
      this.classList.add('touch-active');
      this.dataset.touchStartTime = Date.now();
      
      // Create ripple effect
      const ripple = document.createElement('span');
      ripple.classList.add('touch-ripple');
      
      const rect = this.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.touches[0].clientX - rect.left - size / 2;
      const y = e.touches[0].clientY - rect.top - size / 2;
      
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = x + 'px';
      ripple.style.top = y + 'px';
      
      this.appendChild(ripple);
      
      setTimeout(() => {
        ripple.remove();
      }, 600);
    }
    
    function handleTouchEnd(e) {
      const touchDuration = Date.now() - (parseInt(this.dataset.touchStartTime) || 0);
      const minDuration = 100;
      
      if (touchDuration < minDuration) {
        setTimeout(() => {
          this.classList.remove('touch-active');
        }, minDuration - touchDuration);
      } else {
        this.classList.remove('touch-active');
      }
    }
    
    function handleRippleClick(e) {
      if (!('ontouchstart' in window)) {
        // Desktop click ripple
        const ripple = document.createElement('span');
        ripple.classList.add('touch-ripple');
        
        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        
        this.appendChild(ripple);
        
        setTimeout(() => {
          ripple.remove();
        }, 600);
      }
    }
    
    // Optimize collection card images for lazy loading
    const collectionImages = document.querySelectorAll('.mobile-collection .card-wrapper img');
    collectionImages.forEach(img => {
      if ('loading' in HTMLImageElement.prototype) {
        img.loading = 'lazy';
      }
    });
    
    // Add ARIA labels for accessibility
    document.querySelectorAll('.menu-drawer__localization .disclosure__button').forEach(button => {
      const countryText = button.textContent.trim();
      button.setAttribute('aria-label', `Change country/region. Currently: ${countryText}`);
    });
    
    document.querySelectorAll('.mobile-collection .card-collection-item-one').forEach(card => {
      const titleElement = card.querySelector('.card-heading-q');
      if (titleElement) {
        card.setAttribute('aria-label', `View ${titleElement.textContent.trim()} collection`);
      }
    });
    
    // Make functions available globally
    window.cleanupArrows = cleanupArrows;
    window.styleLanguageSwitcher = styleLanguageSwitcher;
  }
  
  // Add ripple animation styles if not already present
  function addRippleStyles() {
    if (!document.getElementById('premium-ripple-styles')) {
      const style = document.createElement('style');
      style.id = 'premium-ripple-styles';
      style.textContent = `
        .touch-ripple {
          position: absolute;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255, 107, 107, 0.3) 0%, transparent 70%);
          transform: scale(0);
          animation: rippleEffect 0.6s ease-out;
          pointer-events: none;
          z-index: 1;
        }
        
        @keyframes rippleEffect {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        
        .touch-active {
          transform: scale(0.98) !important;
        }
        
        /* Ensure elements have position relative for ripple */
        .menu-drawer__localization .disclosure__button,
        .menu-drawer__account,
        .mobile-collection .card-collection-item-one {
          position: relative;
          overflow: hidden;
        }
      `;
      document.head.appendChild(style);
    }
  }
  
  // Make functions globally available
  window.openMenuDrawer = openMenu;
  window.closeMenuDrawer = closeMenu;
  window.toggleMenuDrawer = toggleMenu;
  
  // Initialize premium features
  addRippleStyles();
  
  // Reinitialize after menu opens
  if (!window.originalOpenMenuDrawer) {
    window.originalOpenMenuDrawer = window.openMenuDrawer;
    window.openMenuDrawer = function() {
      window.originalOpenMenuDrawer();
      setTimeout(() => {
        initializePremiumInteractions();
        if (typeof window.styleLanguageSwitcher === 'function') {
          window.styleLanguageSwitcher();
        }
        if (typeof window.cleanupArrows === 'function') {
          window.cleanupArrows();
        }
      }, 100);
    };
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMenu);
  } else {
    initializeMenu();
  }
  
  // Support for Shopify theme editor (without observer)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => {
        initializeMenu();
        initializePremiumInteractions();
      }, 100);
    });
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(() => {
        initializeMenu();
        initializePremiumInteractions();
      }, 100);
    });
  }
  
  // Debug info for premium features
  console.log('✅ Nutriop Mobile Menu Initialized - COMPLETE FIX v2.0');
  console.log('✅ JS Backdrop: pointer-events managed correctly');
  console.log('✅ CSS Pseudo-element: pointer-events fixed');
  console.log('✅ Details element: force-close implemented');
  console.log('✅ CRITICAL FIX: overflow-hidden-tablet removal added');
  console.log('💡 If issues persist, run: window.forceCleanupMenu()');
  
  // Emergency cleanup function - accessible from console for debugging
  window.forceCleanupMenu = function() {
    console.log('🔧 Force cleanup initiated...');
    
    // Force close ALL details elements
    const allDetails = document.querySelectorAll('menu-drawer > details, header-drawer details, details#Details-menu-drawer-container');
    allDetails.forEach(details => {
      details.removeAttribute('open');
      details.open = false;
      details.classList.remove('menu-opening');
    });
    
    // Clean up backdrop
    if (backdrop) {
      backdrop.style.pointerEvents = 'none';
      backdrop.style.opacity = '0';
      backdrop.style.visibility = 'hidden';
      backdrop.classList.remove('menu-drawer-backdrop--visible');
    }
    
    // Clean up all backdrops (both JS and CSS)
    const allBackdrops = document.querySelectorAll('.menu-drawer-backdrop');
    allBackdrops.forEach(bd => {
      bd.style.pointerEvents = 'none';
      bd.style.opacity = '0';
      bd.style.visibility = 'hidden';
      bd.classList.remove('menu-drawer-backdrop--visible');
    });
    
    // CRITICAL: Remove ALL overflow classes from body
    document.body.classList.remove('menu-open');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-mobile');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.documentElement.style.overflow = '';
    
    // Close menu drawer
    if (menuDrawer) {
      menuDrawer.classList.remove('menu-drawer--open', 'active');
      menuDrawer.setAttribute('aria-hidden', 'true');
      menuDrawer.style.visibility = 'hidden';
      menuDrawer.style.transform = 'translateX(-100%)';
    }
    
    console.log('✅ Cleanup complete! Page should be interactive now.');
  };
  
})();